import React from 'react';

export const Logo: React.FC<{ className?: string }> = ({ className = '' }) => {
  const appName = import.meta.env.VITE_APP_NAME || 'NEXOS';
  const logoUrl = import.meta.env.VITE_APP_LOGO_URL || '/logo.png';
  
  return (
    <img 
      src={logoUrl}
      alt={`${appName} Logo`}
      className={`h-12 w-auto ${className}`}
    />
  );
};
